import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CookieManager from '../../component/cookie-manager';

import PanelLoading from '../../component/panel/loading';

import menu from './menu';

import AccordionTable from '@component/accordion-table';
import request from '@module/http/axios/request';
import VerticalNav from '@component/navigation/verticalnav';
import Actions from '@app/store/action';
import { userHasPlusTier } from '@app/helper/user';
import { isConsentFlagActive } from '@component/consent-manager/flags';

export const renderAccordionWithTable = (accordionTable, i) => {
  const type = accordionTable.getAttribute('data-type');
  const props = {
    type,
    title: accordionTable.querySelector('.accordion-table__title')?.innerHTML,
    description: accordionTable.querySelector('.accordion-table__description')
      ?.innerHTML,

    content: accordionTable.querySelector('.accordion-table__content')
      ?.innerHTML,
    showLabel: accordionTable.querySelector(
      '.accordion-table__toggle-label--show'
    ).innerHTML,
    hideLabel: accordionTable.querySelector(
      '.accordion-table__toggle-label--hide'
    ).innerHTML,
    open:
      accordionTable
        .querySelector('.accordion-table__toggle')
        ?.getAttribute('aria-expanded') === 'true',
  };

  return (
    <section className="accordion-table" key={`${type}-${i}`}>
      <AccordionTable {...props} />
    </section>
  );
};

export const CookiePage = ({ user, session, path, updateFormState }) => {
  const [elements, setHtml] = React.useState([]);
  const [error, setError] = React.useState(null);
  const [intro, cookieManagerIntro, cookieListIntro, cookieList] = elements;
  const hasElements = elements.length > 0;
  const hasError = Boolean(error);

  const parseTagsAndUpdateState = (response) => setHtml(parseTags(response));
  function fetchTemplates() {
    if (hasElements) return;
    const options = {
      path,
      // these headers tell the server to only return page content without header and footer
      responseType: 'text',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    };
    request(options).then(parseTagsAndUpdateState).catch(setError);
  }

  React.useEffect(fetchTemplates, []);

  if (!hasElements || hasError) return <PanelLoading failed={hasError} />;

  return (
    <div className="cookie-page legal--cookies row legal">
      <div className="legal__nav-col">
        <VerticalNav
          items={menu(session.region.country, isConsentFlagActive())}
          activeItem={path}
        />
      </div>
      <div
        className="cookie-page__intro legal__content"
        dangerouslySetInnerHTML={{ __html: intro }}
      />
      <div className="cookie-page__cookie-manager legal__content">
        <div
          className="intro"
          dangerouslySetInnerHTML={{ __html: cookieManagerIntro }}
        />
        <CookieManager
          loggedIn={user.loggedIn !== false}
          isProUser={userHasPlusTier(user)}
          allowTracking={session.privacy.allowTracking}
          updateFormState={updateFormState}
          notified={session.privacy.notified}
        />
      </div>
      <div
        className="legal__content"
        dangerouslySetInnerHTML={{ __html: cookieListIntro }}
      />
      <div className="legal__content">
        {cookieList.map(renderAccordionWithTable)}
      </div>
    </div>
  );
};

function parseTags({ body }) {
  const tpl = document.createElement('template');
  tpl.innerHTML = body;
  return [
    tpl.content.getElementById('cookie-intro').innerHTML,
    tpl.content.getElementById('cookie-manager').innerHTML,
    tpl.content.getElementById('cookie-list-intro').innerHTML,
    Array.from(tpl.content.querySelectorAll('.accordion-table')),
  ];
}

const mapStateToProps = ({ route, session, user }) => ({
  session,
  user,
  path: route.path,
});

const mapDispatchToProps = {
  updateFormState: Actions.Route.setFormState,
};

export default connect(mapStateToProps, mapDispatchToProps)(CookiePage);

CookiePage.propTypes = {
  path: PropTypes.string.isRequired,
  session: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  updateFormState: PropTypes.func.isRequired,
};
